<div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
  <div class="section-header" style="flex-basis: 30px;">
    <div class="section-header-title">
      Fractures
    </div>
    <div style="flex: 1;"></div>
    <div (click)="onAddFractureClick()" style="flex-basis: fit-content; cursor: pointer;"><span style="position: relative; top: 3px;"><mat-icon>add_circle_outline</mat-icon></span></div>
  </div>
  <app-tdo-progress-spinner style="flex: 1;" *ngIf="isLoading"></app-tdo-progress-spinner>
  <div *ngIf="!isLoading" class="section-content" style="flex: 1; max-height: 500px;">
    <mat-checkbox (change)="onShowAllChange($event)">Show All</mat-checkbox>
    <div style="height: 450px; max-height: 450px">
      <tdo-table #tdoTable [isSearchable]="false" [dataSource]="fractures">
        <tdo-table-column displayName="Tooth" propertyName="tooth" isSortable="true" [rowTemplate]="tooth">
          <ng-template #tooth let-row>
            {{getToothNum(row)}}
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Location" propertyName="location" isSortable="true" [rowTemplate]="location">
          <ng-template #location let-row>
            <div style="margin-top: 2px; margin-right: 4px; max-height: 32px; overflow-y: hidden;">
              <app-tdo-dropdown [dataSource]="locationEnumItems"
                                [value]="getValueByEnumId(locationEnumItems, row.model.enumEndoFractureLocationID)"
                                (selectionChange)="onTdoDropdownChange($event, row, 'enumEndoFractureLocationID')"
                                [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"></app-tdo-dropdown>
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Type" propertyName="type" isSortable="true" [rowTemplate]="type">
          <ng-template #type let-row>
            <div style="margin-top: 2px; margin-right: 4px; max-height: 32px; overflow-y: hidden;">
              <app-tdo-dropdown [dataSource]="typeEnumItems"
                                [value]="getValueByEnumId(typeEnumItems, row.model.enumEndoFractureTypeID)"
                                (selectionChange)="onTdoDropdownChange($event, row, 'enumEndoFractureTypeID')"
                                [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"></app-tdo-dropdown>
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Extension" propertyName="extension" isSortable="true" [rowTemplate]="extension">
          <ng-template #extension let-row>
            <div style="margin-top: 2px; margin-right: 4px; max-height: 32px; overflow-y: hidden;">
              <app-tdo-dropdown [dataSource]="extensionEnumItems"
                                [value]="getValueByEnumId(extensionEnumItems, row.model.enumEndoFractureExtensionID)"
                                (selectionChange)="onTdoDropdownChange($event, row, 'enumEndoFractureExtensionID')"
                                [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"></app-tdo-dropdown>
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="TransIllumination" propertyName="transIllumination" isSortable="true" [rowTemplate]="transIllumination">
          <ng-template #transIllumination let-row>
            <div style="margin-top: 2px; margin-right: 4px; max-height: 32px; overflow-y: hidden;">
              <app-tdo-dropdown [dataSource]="transIlluminationEnumItems"
                                [value]="getValueByEnumId(transIlluminationEnumItems, row.model.enumEndoFractureTransilluminationID)"
                                (selectionChange)="onTdoDropdownChange($event, row, 'enumEndoFractureTransilluminationID')"
                                [isObjectValue]="true"
                                dataSourceDisplayKey="ItemDisplayValue"></app-tdo-dropdown>
            </div>
          </ng-template>
        </tdo-table-column>
      </tdo-table>
    </div>
  </div>
  <div class="section-footer" style="flex-basis: 50px; padding-top: 10px;">
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onCancelClick()" class="tdo-button primary-accent" style="margin-right: 6px;">Cancel</button>
    <button (click)="onOkClick()" class="tdo-button primary-accent" style="margin-right: 6px;">Ok</button>
  </div>
</div>
